import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button16Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M16 0H0V10H7V13.0858L3.5251 16.5607C3.13458 16.9512 3.13458 17.5844 3.5251 17.9749C3.91563 18.3654 4.5488 18.3654 4.93932 17.9749L8 14.9142L11.0607 17.9749C11.4512 18.3654 12.0843 18.3654 12.4749 17.9749C12.8654 17.5843 12.8654 16.9512 12.4749 16.5606L9 13.0858V10H16V0Z" />
  </SvgIcon>
);

export default PO28Button16Icon;
